import { tw } from '@/utils/tw';
import BaseStrossleTheme from 'base/components/Strossle/theme';

const Strossle = tw.theme({
  extend: BaseStrossleTheme,
  base: `[&[data-affiliate=nyheter]_[class*=label-above-title]]:text-secondary-700 px-3`,
});

export default Strossle;
